import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { getWebPageVariant, WebPageType } from '../../../constants/webPageType';
import { TranslationLocale } from '../../../i18n';
import { getLocaleText, getUiLocale } from '../../../utils/i18n';
import { ChangeCountry } from '../ChangeCountry';

import './Footer.css';

type FooterProps = {
  webPageType: WebPageType;
  hasPatentText: boolean;
};

export const Footer = memo(({ webPageType, hasPatentText }: FooterProps) => {
  const { t } = useTranslation();
  return (
    <div className="footer unselectable">
      {hasPatentText ? (
        <div className="footer-patent-container">
          <div className="footer-patent-text">
            <div>{t('Provisional Patent: ')}</div>
            <div>{t('No. {NUM}', { NUM: '63669762' })}</div>
            <div>{t('({NUM} Items)', { NUM: 25 })}</div>
          </div>
          <div className="footer-patent-text">
            <div>{t('Copyrights: ')}</div>
            <div>{t('No. {NUM}', { NUM: '1-14003935451' })}</div>
            <div>{t('({NUM} Items)', { NUM: 12 })}</div>
          </div>
        </div>
      ) : null}
      {/* <LanguageRow webPageType={webPageType} /> */}

      <div>
        <ChangeCountry webPageType={webPageType} />
      </div>

      <div className="copyright">
        <p
          className={`footer-text ${
            getWebPageVariant(webPageType).classVariantLight2
          }`}
        >
          {getWebPageVariant(webPageType).fullname}
        </p>
        <p
          className={`footer-text ${
            getWebPageVariant(webPageType).classVariantLight2
          }`}
        >
          ©{new Date().getFullYear()} All Rights Reserved
        </p>
      </div>
    </div>
  );
});

type LanguageRowProps = {
  webPageType: WebPageType;
};

export const LanguageRow = memo(({ webPageType }: LanguageRowProps) => {
  const { i18n } = useTranslation();
  const getLanguageStyle = (locale: TranslationLocale) => ({
    color:
      getUiLocale(i18n.language as TranslationLocale) === getUiLocale(locale)
        ? 'black'
        : undefined,
    cursor: 'pointer',
  });
  const onClick = useCallback(
    (locale: string) => {
      i18n.changeLanguage(locale).catch(console.error);
    },
    [i18n],
  );

  return (
    <div
      className={`lang-row ${
        getWebPageVariant(webPageType).classVariantLight2
      } ${getWebPageVariant(webPageType).classVariantBackground}`}
    >
      <p
        onClick={() => onClick(TranslationLocale.US)}
        style={getLanguageStyle(TranslationLocale.US)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.US))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.HK)}
        style={getLanguageStyle(TranslationLocale.HK)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.HK))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.TW)}
        style={getLanguageStyle(TranslationLocale.TW)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.TW))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.CN)}
        style={getLanguageStyle(TranslationLocale.CN)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.CN))}
      </p>
      <p
        onClick={() => onClick(TranslationLocale.JP)}
        style={getLanguageStyle(TranslationLocale.JP)}
      >
        {getLocaleText(getUiLocale(TranslationLocale.JP))}
      </p>
    </div>
  );
});
